/*jslint browser: true */
/*global window:false, $:false, alert:false */

window.CreateObjectTagClass = function (model, options) {
    "use strict";

    var DEFAULT_TAG_COLOR = '#a8d680';
    var PROGRESS_TIMEOUT = 400;

    var ObjectTag;

    ObjectTag = function () { };
    ObjectTag.prototype.parent_id = null;
    ObjectTag.prototype.isActive = function() {
        return -1 !== model.activeTags.indexOf(this.id);
    };
    ObjectTag.prototype.isVisible = function() {
        return this.isActive() || this.inProgressDebounced();
    };
    ObjectTag.prototype.inProgress = function() {
        var object = model.object();
        if (!object) {
            return false;
        }
        return -1 !== object.progressTags.indexOf(this.id);
    };
    ObjectTag.prototype.inProgressDebounced = function() {
        var object = model.object();
        if (!object) {
            return false;
        }
        return -1 !== object.progressTags.indexOf(this.id);
    };
    ObjectTag.prototype.toggle = function() {
        if (this.inProgress()) {
            return;
        }
        var dfd;
        var object = model.object();
        var tagIds = [ this.id ];
        var progressTags = model.object().progressTags;
        var progressTagsDebounced = model.object().progressTagsDebounced;
        if (this.isActive()) {
            $.each(this.getActiveDescendants(), function(i, tag) {
                tagIds.push(tag.id);
            });
            model.activeTags.removeAll(tagIds);
            dfd = object.removeTags(tagIds);
        }
        else {
            model.activeTags.push(this.id);
            dfd = object.addTag(this.id);
        }

        var timer = setTimeout(function() {
            progressTags.push.apply(progressTags, tagIds);
            progressTagsDebounced.push.apply(progressTagsDebounced, tagIds);
            timer = null;
        }, PROGRESS_TIMEOUT);

        dfd.always(function() {
            if (timer) {
                clearTimeout(timer);
            }
            else {
                progressTagsDebounced.removeAll(tagIds);
            }
            progressTags.removeAll(tagIds);
        });

        dfd.fail(function(msg) {
           alert(msg);
        });
    };
    ObjectTag.prototype.getColor = function() {
        if (this.isActive()) {
            var tag = this;
            do {
                if (tag.color) {
                    return tag.color;
                }
                tag = tag.getParent();
            } while(tag);
            return DEFAULT_TAG_COLOR;
        }
        else {
            return 'inherit';
        }
    };
    ObjectTag.prototype.getBackgroundColor = function() {
        var tag = this;
        do {
            if (tag.color) {
                return tag.color;
            }
            tag = tag.getParent();
        } while(tag);
        return '';
    };
    ObjectTag.prototype.getBorderColor = function() {
        var tag = this;
        do {
            if (tag.border_color) {
                return tag.border_color;
            }
            tag = tag.getParent();
        } while(tag);
        return '';
    };
    ObjectTag.prototype.getTextColor = function() {
        var tag = this;
        do {
            if (tag.text_color) {
                return tag.text_color;
            }
            tag = tag.getParent();
        } while(tag);
        return '';
    };
    ObjectTag.prototype.isGold = function() {
        var tag = this;
        do {
            if (tag.is_gold) {
                return tag.is_gold;
            }
            tag = tag.getParent();
        } while(tag);
        return false;
    };
    ObjectTag.prototype.getParent = function() {
        var result = null;
        var parent_id = this.parent_id;
        if (!parent_id) {
            return result;
        }
        $.each(ObjectTag.All, function(i, tag) {
            if (tag.id === parent_id) {
                result = tag;
                return false; // brake each
            }
            return true;
        });
        return result;
    };
    ObjectTag.prototype.getChilds = function() {
        var id = this.id;
        return $.grep(ObjectTag.All, function(tag) {
            return tag.parent_id === id;
        });
    };
    ObjectTag.prototype.getActiveChilds = function() {
        return $.grep(this.getChilds(), function(tag) {
            return tag.isActive();
        });
    };
    ObjectTag.prototype.hasChilds = function() {
        return 0 !== this.getChilds().length;
    };
    /**
     * @returns {Array} Все активные потомки
     */
    ObjectTag.prototype.getActiveDescendants = function() {
        var result = [];
        $.each(this.getActiveChilds(), function(i, childTag) {
            result.push(childTag);
            result.push.apply(result, childTag.getActiveDescendants());
        });
        return result;
    };
    ObjectTag.prototype.getActiveDescendantsWithoutChilds = function() {
        return $.grep(this.getActiveDescendants(), function(childTag) {
            return childTag.hasChilds();
        });
    };

    /**
     * @static
     * @type {ObjectTag}
     */
    ObjectTag.Root = $.extend(new ObjectTag(), { id: null });

    /**
     * @static
     */
    ObjectTag.All = $.map(options.tags, function(tagData) {
        return $.extend(new ObjectTag(), tagData);
    });

    /**
     * @static
     * @returns {boolean}
     */
    ObjectTag.HasVisibleTags = function() {
        var result = false;
        $.each(ObjectTag.All, function(i, tag) {
            if (tag.isVisible()) {
                result = true;
                return false;
            }
        });
        return result;
    };

    return ObjectTag;
};